import React from "react";
import MyModal from "../../Common/my-modal/my-modal.component";
import ModalForm from "./modal-form";

interface ConvertSubscriptionModalProps {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
  accountName?: string;
  subscriptionPlan?: {
    name: string;
    description: string;
    price: string;
  };
}

const ConvertSubscriptionModal: React.FC<ConvertSubscriptionModalProps> = ({
  show,
  onClose,
  onConfirm,
}) => {
  return (
    <MyModal show={show} onHide={onClose}>
      <ModalForm onClose={onClose} onConvert={onConfirm} />
    </MyModal>
  );
};

export default ConvertSubscriptionModal;

